<template>
  <div v-if="!_isEmpty($store.getters.get_managed_active_admins_details)">
    <TypeToSelect
      v-for="(admin_user_id, index) in selected_host"
      :key="index"
      v-model="selected_host[index]"
      :options="$store.getters.get_managed_active_admins_details"
      label_field="name"
      value_field="admin_user_id"
      class="white"
      :disabled="disabled"
      :filter-by="dropdown_filter"
    >
      <template v-slot:selected-option="option">
        <div class="profile-details">
          <img
            v-if="option.profile_picture"
            :src="option.profile_picture"
            width="30"
            style="border-radius:50%;"
          />
          <div>
            <div class="txt-h5">{{ option.name }}</div>
            <div class="txt-help">{{ option.email }}</div>
          </div>
        </div>
      </template>
      <template v-slot:option="option">
        <div class="profile-details">
          <img
            v-if="option.profile_picture"
            :src="option.profile_picture"
            width="30"
            style="border-radius:50%;"
          />
          <div>
            <div class="txt-h5">{{ option.name }}</div>
            <div class="txt-help">{{ option.email }}</div>
          </div>
        </div>
      </template></TypeToSelect
    >
  </div>
</template>

<script>
//yet to implement multiple
import TypeToSelect from "@/components/form_elements/TypeToSelect.vue";

export default {
  name: "HostSelector1ToN",
  components: {
    TypeToSelect
  },
  model: {
    prop: "selected_host",
    event: "changed-selected-host"
  },
  props: {
    selected_host: {
      type: Array
    },
    max_host: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    dropdown_filter(option, label, search) {
      let search_text = search.toLowerCase();
      return (
        (label || "").toLowerCase().indexOf(search_text) > -1 ||
        option.email.toLowerCase().indexOf(search_text) > -1
      );
    }
  }
};
</script>
<style>
.profile-details {
  display: flex;
  align-items: center;
}
.profile-details img {
  margin-right: 10px;
}
.et-create-host-selector .ttf-v-selector::after {
  top: 20px;
  right: 14px;
}
.et-create-host-selector .ttf-v-selector.vs--open .profile-details {
  display: none;
}
.et-create-host-selector .ttf-v-selector .vs__selected {
  max-width: unset;
  margin: 8px 2px;
}
.wpcal-v-select-body-dropdown li .txt-h5 {
  font-size: 14px;
}
.wpcal-v-select-body-dropdown li .txt-help {
  color: #7c7d9c;
  font-size: 13px;
  margin-top: -3px;
}
.wpcal-v-select-body-dropdown li.vs__dropdown-option--highlight .txt-help {
  color: #fff;
}
.wpcal-v-select-body-dropdown li .profile-details {
  margin: 5px 0;
}
</style>
